module.exports = __webpack_public_path__ + "img/pollola_sisalta12.9e0d668e.jpg";